import React from 'react'
import {
  BookingCardBookCardContainer,
  BookingCardCardImg,
  BookingCardCardTitle,
  BookingCardCircle,
  BookingCardCircleInner,
  BookingCardGap
} from './style'

const BuyerPaymentMethodOption = ({ img, id, cardInfo, isSelect, setIsSelect }) => {

  return (
    <BookingCardBookCardContainer onClick={() => setIsSelect(id)}>
    <BookingCardGap container alignItems='center'>
      <BookingCardCardImg src={img} alt="Payment Card" />
      <BookingCardCardTitle>{cardInfo}</BookingCardCardTitle>
    </BookingCardGap>
    <BookingCardCircle>
      {isSelect && <BookingCardCircleInner />}
    </BookingCardCircle>
    </BookingCardBookCardContainer>
  )
}

export default BuyerPaymentMethodOption
